import Text from 'components/elements/texts/Text'
import { CLIENT_SETTINGS } from 'constants/clientSettings'
import React, { useCallback, useState } from 'react'
import styled from 'styled-components'
import { useReceptionNo } from 'utils/commonHooks'
import { getGtag } from 'utils/gtag'

import Modal from './Modal'
import { useHistory } from 'react-router-dom'
import { PAGE_PATH } from '../../../constants/pagePath'

/**
 * オペレーターに入力内容を連携しない旨の注意書きを表示する画面の一覧
 * 表示対象は、「QNステータスがFILLING」かつ、「スタート画面」を除いた画面
 */
const fillingPagePathList: Array<string> = [
  PAGE_PATH.RE_ACCESS,
  PAGE_PATH.RESERVATION,
  PAGE_PATH.TROUBLE_PLACE,
  PAGE_PATH.VEHICLE_STATE,
  PAGE_PATH.ENGINE_TROUBLE,
  PAGE_PATH.FLAT_TIRE,
  PAGE_PATH.ACCIDENT,
  PAGE_PATH.FALLING_WHEEL,
  PAGE_PATH.EMPTY_FUEL,
  PAGE_PATH.LOSS_KEY,
  PAGE_PATH.OTHERS,
  PAGE_PATH.TRANSPORT_DESTINATION,
  PAGE_PATH.TROUBLE_PLACE_SURROUNDING,
  PAGE_PATH.SERVICE_INFORMATION,
  PAGE_PATH.CONTRACT_INFORMATION,
  PAGE_PATH.CONFIRMATION,
]

/**
 * 架電モーダル 呼び出し元を含む
 */
const CallModal: React.FC<CallModalProps> = (props) => {
  const [on, setOn] = useState(!props.children)
  const receptionNo = useReceptionNo()
  const history = useHistory()
  const modalOpen = useCallback(() => {
    setOn(true)
  }, [])

  const close = useCallback(() => {
    setOn(false)
    if (props.onClose) {
      props.onClose()
    }
  }, [])

  const call = useCallback(() => {
    const gtag = getGtag()
    gtag('event', '受付番号_架電', { ['caller_reception_no']: receptionNo })
    setOn(false)
    props.isTransitionReAccess && history.push(PAGE_PATH.RE_ACCESS)
  }, [props.isTransitionReAccess])

  /** 架電ポップアップに表示するメッセージ */
  const modalMessage: string = React.useMemo(() => {
    const message = 'ロードアシスタンスのオペレーターへ電話をかけますか？'

    /** 架電ポップアップのメッセージに注意書きを表示するかのフラグ */
    const isDisplayAnnotation: boolean = fillingPagePathList.some(
      (pagePath) => pagePath === history.location.pathname
    )

    if (isDisplayAnnotation) {
      return message.concat(
        '\n※ここまでの入力内容はオペレーターに連携されません。'
      )
    }
    return message
  }, [history.location.pathname])

  return (
    <React.Fragment>
      {props.children && <div onClick={modalOpen}>{props.children}</div>}
      <Modal
        on={props.children ? on : props.isOpened ?? false}
        type="center"
        greyBack
        scrollLock
      >
        <CallModalArea>
          <Text>{modalMessage}</Text>
          <CallModalActionArea>
            <CallAction onClick={close}>いいえ</CallAction>
            <CallAction onClick={call} bold href={`tel:${CLIENT_SETTINGS.tel}`}>
              はい
            </CallAction>
          </CallModalActionArea>
        </CallModalArea>
      </Modal>
    </React.Fragment>
  )
}

type CallModalProps = {
  isTransitionReAccess: boolean
  children?: React.ReactNode
  isOpened?: boolean
  onClose?: () => void
}

const CallModalArea = styled.div`
  width: calc(100vw - 72px);
  padding: 16px;
  color: #111111;
  text-align: left;
  background: #ffffff;
  border-radius: 6px;
  pointer-events: auto;
`

const CallModalActionArea = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
`

const CallAction = styled.a<{ bold?: boolean }>`
  margin-left: 24px;
  color: #1e90ff;
  ${(props): string => (props.bold ? 'font-weight: bold' : '')};
`

export default React.memo<CallModalProps>(CallModal)
